@if (isDialog) {
    <h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
        <mat-label>{{'general.presetAnimations' | transloco}}</mat-label>
        <div class="dlg-drag-handle" cdkDragHandle>
            <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
                <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
    </h1>

    <div mat-dialog-content>
        @if (animationTemplates[mode]?.length > 0) {
            <div class="templates">
                @for (item of animationTemplates[mode]; track item) {
                    <div class="animation-template">
                        <img width="90" height="90" ngSrc="./assets/animations/v2/{{item.image}}" class="mouseOver"
                            matTooltip="{{item.name}}" [ngClass]="{'selected': item.name === selection[mode]}"
                            (click)="onSelectAnimation(item)">
                    </div>
                }
            </div>
        } @else {
            <ng-container [ngTemplateOutlet]="comingSoonTemplate"></ng-container>
        }

        <mat-form-field class="animationFieldWidth">
            <mat-label>{{mode}} {{'general.duration' | transloco}}</mat-label>
            <input inputrestriction="numbers" matInput step="0.1" type="number" min="0" max="60"
                [(ngModel)]="duration[mode]" placeholder="{{'general.seconds' | transloco}}" required>
        </mat-form-field>

        <button mat-raised-button color="primary" (click)="onPresetAnimation()"
            style="float: right; top: 15px; padding-right: 20px; margin-right: 20px"
            [disabled]="!selection[mode]">
            <mat-icon>check</mat-icon>
            {{'general.apply' | transloco}}
        </button>
    </div>

} @else {
    <div [ngClass]="{disableAnimation: disableUI}" style="padding: 1px; margin: 1px">
        <mat-tab-group [@.disabled]="true" tabGroupDrag class="mini-tab" mat-stretch-tabs="false" mat-align-tabs="start">
            <mat-tab [disabled]="disableUI">
                <ng-template mat-tab-label>
                    <mat-icon>join_left</mat-icon>
                    <span class="tab-label">{{'general.onBegin' | transloco}}</span>
                </ng-template>
                @if (animationTemplates["In"]?.length > 0) {
                    <div class="templates">
                        @for (item of animationTemplates["In"]; track item) {
                            <div class="animation-template">
                                <img width="90" height="90" ngSrc="./assets/animations/v2/{{item.image}}" class="mouseOver"
                                    matTooltip="{{item.name}}" [ngClass]="{'selected': item.name === selection['In']}"
                                    (click)="onSelectAnimation(item)">
                            </div>
                        }
                    </div>
                } @else {
                    <ng-container [ngTemplateOutlet]="comingSoonTemplate"></ng-container>
                }

                <mat-form-field class="animationFieldWidth">
                    <mat-label>In {{'general.duration' | transloco}}</mat-label>
                    <input inputrestriction="numbers" matInput step="0.1" type="number" min="0" max="60"
                        [(ngModel)]="duration['In']" placeholder="{{'general.seconds' | transloco}}" required>
                </mat-form-field>
            </mat-tab>
            
            <mat-tab [disabled]="disableUI">
                <ng-template mat-tab-label>
                    <mat-icon>join_inner</mat-icon>
                    <span class="tab-label">{{'general.onPlay' | transloco}}</span>
                </ng-template>
                @if (animationTemplates["Play"]?.length > 0) {
                    <div class="templates">
                        @for (item of animationTemplates["Play"]; track item) {
                            <div class="animation-template">
                                <img width="90" height="90" ngSrc="./assets/animations/v2/{{item.image}}" class="mouseOver"
                                    matTooltip="{{item.name}}" [ngClass]="{'selected': item.name === selection['Play']}"
                                    (click)="onSelectAnimation(item)">
                            </div>
                        }
                    </div>
                } @else {
                    <ng-container [ngTemplateOutlet]="comingSoonTemplate"></ng-container>
                }

                <mat-form-field class="animationFieldWidth">
                    <mat-label>Play {{'general.duration' | transloco}}</mat-label>
                    <input inputrestriction="numbers" matInput step="0.1" type="number" min="0" max="60"
                        [(ngModel)]="duration['Play']" placeholder="{{'general.seconds' | transloco}}" required>
                </mat-form-field>
            </mat-tab>

            <mat-tab [disabled]="disableUI">
                <ng-template mat-tab-label>
                    <mat-icon>join_right</mat-icon>
                    <span class="tab-label">{{'general.onEnd' | transloco}}</span>
                </ng-template>

                @if (animationTemplates["Out"]?.length > 0) {
                    <div class="templates">
                        @for (item of animationTemplates["Out"]; track item) {
                            <div class="animation-template">
                                <img width="90" height="90" ngSrc="./assets/animations/v2/{{item.image}}" class="mouseOver"
                                    matTooltip="{{item.name}}" [ngClass]="{'selected': item.name === selection['Out']}"
                                    (click)="onSelectAnimation(item)">
                            </div>
                        }
                    </div>
                } @else {
                    <ng-container [ngTemplateOutlet]="comingSoonTemplate"></ng-container>
                }

                <mat-form-field class="animationFieldWidth">
                    <mat-label>Out {{'general.duration' | transloco}}</mat-label>
                    <input inputrestriction="numbers" matInput step="0.1" type="number" min="0" max="60"
                        [(ngModel)]="duration['Out']" placeholder="{{'general.seconds' | transloco}}" required>
                </mat-form-field>
            </mat-tab>
        </mat-tab-group>
    </div>
}

<ng-template #comingSoonTemplate>
    <br/>
    <br/>
    <br/>
    <div style="text-align: center; font-size: 1.2em; min-height: 300px;">
      animation pre-set coming soon...
    </div>
</ng-template>